/***
 *
 *   AUTHENTICATION
 *   Auth provider to manage auth functions throughout
 *   the application. <PrivateRoute> component to
 *   protect internal application routes from unauthenticated
 *   access.
 *
 **********/

import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { Navigate } from "react-router-dom";

// auth context
export const AuthContext = createContext();

const components = require("../components/lib");
const permissions = require("./permissions");

export function AuthProvider(props) {
  const cache = JSON.parse(localStorage.getItem("user"));
  const [user, setUser] = useState(cache);
  const auth = components.useAPI(user ? "/api/auth" : null);

  useEffect(() => {
    if (!auth.loading && auth.data) {
      auth.data.authenticated ? update(auth.data) : signout();
    }
  }, [auth.loading, auth.data]);

  useEffect(() => {
    if (user?.token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
    }
  }, [user]);

  useEffect(() => {
    if (user?.token) {
      axios.defaults.headers.common["Authorization"] = "Bearer " + user.token;
      if (window.location.pathname === "/") {
        window.location.replace("/app/dashboard");
      }
    }
  }, [user]);

  function signin(res) {
    if (res.data) {
      localStorage.setItem("user", JSON.stringify(res.data));
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + res.data.token;
      window.dispatchEvent(new Event("signin"));

      return (window.location = res.data.onboarded
        ? "/app/dashboard"
        : "/app/dashboard");
    }
  }

  async function signout() {
    axios({ method: "delete", url: "/api/auth" });
    localStorage.clear();
    return (window.location = "/");
  }

  async function switchAccount(id) {
    const res = await axios({
      method: "post",
      url: "/api/auth/switch",
      data: { account: id },
    });

    if (res.data) signin(res);
  }

  function update(data) {
    if (localStorage.getItem("user")) {
      let user = JSON.parse(localStorage.getItem("user"));
      for (let key in data) {
        if (Array.isArray(data[key])) {
          user[key] = data[key];
        } else if (typeof data[key] === "object") {
          for (let innerKey in data[key]) {
            user[key][innerKey] = data[key][innerKey];
          }
        } else {
          user[key] = data[key];
        }
      }

      localStorage.setItem("user", JSON.stringify(user));
      setUser(user);
    }
  }

  return (
    <AuthContext.Provider
      value={{
        user: user,
        signin: signin,
        signout: signout,
        update: update,
        switchAccount: switchAccount,
        permission: permissions[user?.permission],
      }}
      {...props}
    />
  );
}

// custom route object checks for an auth token before
// rendering the route – redirects if token is not present
export function PrivateRoute(props) {
  // check user exists
  const user = JSON.parse(localStorage.getItem("user"));

  if (user?.token) {
    if (user?.token && permissions[user?.permission]?.[props.permission]) {
      return props.children;
    }
  }

  // user is not authenticated
  return <Navigate to="/" />;
}
